export const GESTURE_INTENT_DISTANCE = 10
const VELOCITY_WINDOW_MS = 100
const MAX_VELOCITY_SAMPLES = 8

export interface PointerSample {
  x: number
  y: number
  time: number
}

export function hasGestureIntent(
  dx: number,
  dy: number,
  threshold = GESTURE_INTENT_DISTANCE,
) {
  return dx * dx + dy * dy >= threshold * threshold
}

export class VelocityTracker {
  private samples: PointerSample[] = []

  reset(x: number, y: number, time: number) {
    this.samples = [{ x, y, time }]
  }

  add(x: number, y: number, time: number) {
    const latest = this.samples[this.samples.length - 1]
    if (latest && time < latest.time) return
    if (latest && time === latest.time) {
      latest.x = x
      latest.y = y
    } else {
      this.samples.push({ x, y, time })
    }

    const cutoff = time - VELOCITY_WINDOW_MS
    while (this.samples.length > 1 && this.samples[0].time < cutoff) {
      this.samples.shift()
    }
    while (this.samples.length > MAX_VELOCITY_SAMPLES) {
      this.samples.shift()
    }
  }

  velocity(): { x: number; y: number } {
    if (this.samples.length < 2) return { x: 0, y: 0 }
    const first = this.samples[0]
    const last = this.samples[this.samples.length - 1]
    const elapsedSeconds = (last.time - first.time) / 1000
    if (elapsedSeconds <= 0) return { x: 0, y: 0 }
    return {
      x: (last.x - first.x) / elapsedSeconds,
      y: (last.y - first.y) / elapsedSeconds,
    }
  }
}
